type EventName = 'job:mutated' | 'inspection:mutated' | 'report:mutated'

interface EventDetail {
  id?: string
  jobId?: string
  previousId?: string
  nextId?: string
}

class AppEventBus {
  private target = new EventTarget()

  emit(event: EventName, detail?: EventDetail) {
    this.target.dispatchEvent(new CustomEvent(event, { detail }))
  }

  on(event: EventName, handler: (e: CustomEvent<EventDetail>) => void): () => void {
    const listener = handler as EventListener
    this.target.addEventListener(event, listener)
    return () => this.target.removeEventListener(event, listener)
  }
}

export const eventBus = new AppEventBus()
